import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { ExternalLinkButton, PrimaryButtonClassname } from '@shared/components/buttons';

export const uploaderUrl =
  'https://orderbot-uploader-releases.s3.us-west-2.amazonaws.com/Orderbot+Companion.exe';

/**
 * Uploader download link. `primary` renders the emerald primary-button styling
 * for use as an empty-state call to action; the default gray variant is kept
 * for the vendors page.
 */
export const DownloadUploaderButton = ({ primary = false }: { primary?: boolean }) => {
  if (primary) {
    return (
      <a href={uploaderUrl} className={PrimaryButtonClassname}>
        <ArrowDownTrayIcon className="size-5" />
        Download the uploader
      </a>
    );
  }

  return <ExternalLinkButton href={uploaderUrl}>Download the uploader</ExternalLinkButton>;
};
